import React, { useEffect, useContext } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { Call } from "@twilio/voice-sdk";
import { ActionCommon, useAppSelector, VRIAppStateType } from "..";
import {
  AppRouteUi,
  CallStatusType,
} from "../../configs";
import { AudioDeviceContext } from "..";
import { ActionAudioCall } from "../../core/Redux/Slices/sliceCall";
import { logger } from "../../utils";

export const CallContext = React.createContext<any>(12);

export function CallContextProvider(props: React.PropsWithChildren<{}>) {
  const [callinfo, setCallinfo] = React.useState<Call>(Object);
  const [isAccepted, setIsAccepted] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const {device} = useContext(AudioDeviceContext);
  //for OPI calling

  const data = useAppSelector(
    (state: VRIAppStateType) => ({
      userRole: state.auth.profile?.userRole,
      userId: state.auth.profile?.id,
      callerId: state.ui.callerId,
      audioCallStatus: state.audioCall.audioCallStatus,
      receiverId: state.ui.receiverId,
      twilioDeviceStatus: state.common.twilioDeviceStatus,
    }),
    shallowEqual
  );

  useEffect(() => {

    if (!device) return;

    const handleDeviceUnregistered = () => {
      dispatch(ActionCommon.setTwilioDeviceStatus('offline'));
    };
    const handleDeviceRegistered = () => {
      dispatch(ActionCommon.setTwilioDeviceStatus('online'));
    };

    device.on('unregistered', handleDeviceUnregistered);
    device.on('registered', handleDeviceRegistered);

    return () => {
      device.off('unregistered', handleDeviceUnregistered);
      device.off('registered', handleDeviceRegistered);
    };
  }, [dispatch, device]);

  useEffect(() => {

    if(!device){
      return
    }

    const listenerIncoming = function (call: Call) {
      if (
        data.audioCallStatus?.current == CallStatusType.Canceled &&
        data.audioCallStatus?.prev == CallStatusType.Zero
      ) {
      } else {
        const callId =
          call.customParameters?.get("CallId") ??
          call.customParameters?.get("callId") ??
          "";
        dispatch(
          ActionAudioCall.SetAudioCallStatus({
            prev: CallStatusType.Initiated,
            current: CallStatusType.Ringing,
          })
        );
        setCallinfo(call);
        history.push(AppRouteUi.IncomingCall.Root);
      }
    };
    const listenerConnect = function (call: Call) {
      logger({
        message: "[CallContext] Call accepted/connected",
        data: {
          callSid: call.customParameters?.get("CallSid") ?? call.customParameters?.get("callSid"),
        },
      });
      dispatch(
        ActionAudioCall.SetAudioCallStatus({
          prev: CallStatusType.Ringing,
          current: CallStatusType.Established,
        })
      );
      setIsAccepted(true);
      const callId =
        call.customParameters?.get("CallId") ??
        call.customParameters?.get("callId") ??
        "";
      const receiverId =
        call.customParameters?.get("ReceiverId") ??
        call.customParameters?.get("to") ??
        "";
      if (data.userId == receiverId) {
        let _startTime = new Date().toISOString();
        // onUpdate(callId, {
        //   callStatus: CallStatusType.Established,
        //   startTime: _startTime,
        // });
      }
    };

    const listenerOutgoing = function (call: any) {
      setCallinfo(call);
      console.log("outgoing", call);
    };

    const handleIncoming = (call: Call) => {
      logger({
        message: "[CallContext] Incoming call",
        data: {
          callSid: call.customParameters?.get("CallSid") ?? call.customParameters?.get("callSid"),
        },
      });
      listenerIncoming(call);

      call.on("disconnect", (err?: Error) => {
        if ((call as any)._isAnswered) {
          dispatch(
            ActionAudioCall.SetAudioCallStatus({
              prev: CallStatusType.Established,
              current: CallStatusType.Completed,
            })
          );
        }
      });

      call.on("accept", listenerConnect);
    };

    device.on("incoming", handleIncoming);

    return () => {
      device.off("incoming", handleIncoming);
    };
  }, [history, device]);

  const getAudioCallEndTime = () => {
    return new Date().toString();
  };

      return(
    <CallContext.Provider
      value={{
      callinfo,
      isAccepted,
      setIsAccepted,
    }}
    >
    { props.children }
    </CallContext.Provider >
  );
}
